export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
